import { NavLink } from 'react-router-dom'


const DashboardMenu = () => {

    return (
        <div className='fl-cl dashboardMenu__container'>
            <div className='fl-cl dashboardMenu__containerDiv'>
                <ul className='fl-cl dashboardMenu__ul'>
                    <div className='fl-cl'><li><NavLink to="/dashboard/movies">Peliculas</NavLink></li></div>
                    <div className='fl-cl'><li><NavLink to="/dashboard/series">Series</NavLink></li></div>
                    <div className='fl-cl'><li><NavLink to="/dashboard/carousel">Carousel</NavLink></li></div>
                </ul>
            </div>
        </div>
    )
}

export default DashboardMenu;